<template>
  <b-dropdown class="dropdown-form" v-bind:class="{'color-button': (!allSelected)}" ref="dropdown">
    <template slot="button-content">
      <span v-if="allSelected || getPropertyType.length === 0">Property Type</span>
      <span v-if="!allSelected">{{ displaySelected }}</span>
      <reset-button v-if="!allSelected" v-on:x-button-clicked="resetPropertyType"></reset-button>
    </template>
    <b-dropdown-form>
      <div class="container-fluid">
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" v-model="allSelected">
              <label class="form-check-label">All</label>
            </div>
          </div>
        </div>
        <hr>

        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Townhouse" v-model="propertyType">
              <label class="form-check-label">Townhouse</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="House" v-model="propertyType">
              <label class="form-check-label">House</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Land" v-model="propertyType">
              <label class="form-check-label">Land</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Condo" v-model="propertyType">
              <label class="form-check-label">Condo</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Multi-Family" v-model="propertyType">
              <label class="form-check-label">Multi-Family</label>
            </div>
          </div>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import defaultValues from '../../../../../store/lib/defaultValues.js'
import ResetButton from '../../../../general/buttons/CircleEnclosedXButton.vue'

export default {
  data () {
    return {
      propertyTypeOptions: defaultValues.propertyType
    }
  },
  components: {
    ResetButton
  },
  methods: {
    ...mapMutations('homeSearch', [
      'updatePropertyType'
    ]),
    resetPropertyType () {
      this.updatePropertyType(defaultValues.propertyType)
    }
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getPropertyType'
    ]),
    propertyType: {
      get () {
        return this.getPropertyType
      },
      set (value) {
        this.updatePropertyType(value)
      }
    },
    allSelected: {
      get () {
        // Return true only if the arrays contain the same elements
        if (this.getPropertyType.length === this.propertyTypeOptions.length) {
          this.getPropertyType.forEach((element) => {
            if (!this.propertyTypeOptions.includes(element)) {
              return false
            }
          })
          return true
        }
        return false
      },
      set () {
        if (this.allSelected) {
          this.updatePropertyType([])
          return false
        } else {
          this.updatePropertyType(this.propertyTypeOptions)
          return true
        }
      }
    },
    displaySelected () {
      let returnArray = []
      this.getPropertyType.forEach(element => returnArray.push(element.charAt(0)))
      return returnArray.join(', ')
    }
  }
}
</script>

<style scoped>
.dropdown-form >>> .dropdown-item {
  color:#4f4f4f !important;
}

.dropdown-row {
  width: 220px;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}

.form-check {
  align-items: left !important;
  justify-content: left !important;
}

.right-dropdown-col, .left-dropdown-col {
  padding: 0;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/PropertyType.vue